export default class Header {
  constructor(element) {
    this.element = element;
    this.html = document.documentElement;
    this.body = document.body;
    this.trigger = this.element.querySelector('#mobile-trigger');
    this.menu = this.element.querySelector('.menu-links');
    this.menuListItems = this.element.querySelector('.menu-list-items');

    this.scrollThreshold = 10;

    this.init();
    this.initNavMobile();
    this.initMobileNav();
  }

  init() {
    if (!this.element || !this.menuListItems) return;

    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const isDesktop = window.innerWidth > 1024;

      const targetClass = isDesktop ? "desktopfixed" : "mobiletopfixed";
      const wrongClass = isDesktop ? "mobiletopfixed" : "desktopfixed";

      if (scrollTop > this.scrollThreshold) {
        this.menuListItems.classList.add(targetClass);
        this.menuListItems.classList.remove(wrongClass);
      } else {
        this.menuListItems.classList.remove("desktopfixed", "mobiletopfixed");
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
  }

  initNavMobile() {
    if (this.trigger && this.menu) {
      this.trigger.addEventListener("click", () => {
        const isActive = this.menu.classList.contains("active");

        this.trigger.classList.toggle("active");
        this.menu.classList.toggle("active");
        this.element.classList.toggle("menu-open");

        if (!isActive) {
          this.html.style.overflow = 'hidden';
          this.body.style.overflow = 'hidden';
        } else {
          this.html.style.overflow = '';
          this.body.style.overflow = '';
        }
      });
    }
  }

  initMobileNav() {
    const header = document.getElementById('header');
    const hoverTriggers = header.querySelectorAll('.hoverTrigger');

    if (this.trigger) {
      this.trigger.addEventListener('click', () => {
        const isActive = document.body.classList.toggle('nav-is-active');
        header.classList.toggle('mobile-open', isActive);
        if (!isActive) {
          hoverTriggers.forEach((trigger) => trigger.classList.remove('open'));
        }
      });
    }

    hoverTriggers.forEach((trigger) => {
      const dropdown = trigger.querySelector('.drop-down-multilevel');
      const mainLink = trigger.querySelector(':scope > a');
      if (dropdown && mainLink) {
        mainLink.addEventListener('click', (e) => {
          if (window.innerWidth > 1199) return;
          e.preventDefault();
          hoverTriggers.forEach((otherTrigger) => {
            if (otherTrigger !== trigger) {
              otherTrigger.classList.remove('open');
              const otherDropdown = otherTrigger.querySelector('.drop-down-multilevel');
              if (otherDropdown) otherDropdown.classList.remove('open');
            }
          });
          const isOpen = trigger.classList.toggle('open');
          if (dropdown) dropdown.classList.toggle('open', isOpen);
        });
      }
    });
  }

}